import React, { useState } from 'react';
import axios from 'axios';
import { Box, Button, TextField, Typography, Alert, Paper, Dialog, DialogTitle, DialogContent } from '@mui/material';
import config from 'src/config';
import { useAuth } from 'src/util/authenticationProvider';
import { useTranslation } from 'react-i18next';

export default function Redeem() {
  const { t } = useTranslation();
  const [luckyNumber, setLuckyNumber] = useState('');
  const [loading, setLoading] = useState(false);
  const [response, setResponse] = useState<any>(null);
  const [error, setError] = useState('');
  const [prizeOpen, setPrizeOpen] = useState(false);
  const authContext = useAuth();


  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setResponse(null);
    setLoading(true);

    try {
      const res = await axios.post(
        config.apiUrl + `/api/lottery/redeem/${luckyNumber}`,
        {},
        {
          headers: {
            'Authorization': 'Bearer ' + (authContext.tokens?.accessToken ?? '')
          }
        }
      );
      const data = res.data.content;
      if (data.status === 9000 && data.participant && data.participant.wonItem) {
        setResponse(data);
        setPrizeOpen(true);
      } else if (data.status === 9000 && data.participant) {
        setResponse(data);
      } else {
        setError(data.message || t('redeem.errorDefault'));
      }
    } catch (err: any) {
      setError(t('redeem.errorServer'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Paper sx={{ p: 4, maxWidth: 400, mx: 'auto', mt: 6 }}>
      <Typography variant="h5" gutterBottom>
        {t('redeem.title')}
      </Typography>
      <Box component="form" onSubmit={handleSubmit} sx={{ mb: 2 }}>
        <TextField
          label={t('redeem.luckyNumber')}
          type="number"
          value={luckyNumber}
          onChange={e => setLuckyNumber(e.target.value)}
          fullWidth
          required
          sx={{ mb: 2 }}
        />
        <Button
          type="submit"
          variant="contained"
          color="primary"
          disabled={loading || !luckyNumber}
          fullWidth
        >
          {loading ? t('redeem.checking') : t('redeem.redeemButton')}
        </Button>
      </Box>
      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
      {response && (
        <Alert severity="success">
          <Typography variant="subtitle1" gutterBottom>
            {response.message || t('redeem.success')}
          </Typography>
          <Typography>
            {t('redeem.winner')}: {response.participant.name}
          </Typography>
          <Typography>
            {t('redeem.prize')}: {response.participant.wonItem?.description || t('redeem.noPrize')}
          </Typography>
        </Alert>
      )}
      {/* Prize popup */}
      <Dialog open={prizeOpen} onClose={() => setPrizeOpen(false)}>
        <DialogTitle>{t('redeem.popupTitle')}</DialogTitle>
        <DialogContent>
          {response?.participant?.wonItem && (
            <Box sx={{ textAlign: 'center' }}>
              <Typography variant="h6" sx={{ mb: 2 }}>
                {response.participant.wonItem.description}
              </Typography>
              <img
                src={response.participant.wonItem.image}
                alt={response.participant.wonItem.description}
                style={{ maxWidth: '100%', maxHeight: 300, borderRadius: 8 }}
              />
            </Box>
          )}
        </DialogContent>
      </Dialog>
    </Paper>
  );
}
